import { render, staticRenderFns } from "./ApiTokensView.vue?vue&type=template&id=1af88fd1&scoped=true&"
import script from "./ApiTokensView.vue?vue&type=script&lang=js&"
export * from "./ApiTokensView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af88fd1",
  null
  
)

export default component.exports